import { useCallback, useEffect, useState, useRef } from 'react';
import api from '@/services/api';
import { useAuth, useChatInteract } from '@chainlit/react-client';
import { FileData } from './useRegisterAssistant';
import { toast } from 'sonner';
import { manageErrors } from '@/lib/manageErrors';
// import { useNavigate } from 'react-router-dom';

export interface IAssistantsList {
  id: string;
  name: string;
  description: string;
  system_prompt: string;
  suggested_prompts: string[];
  created_at: string;
  tools?: string[];
  logo?: string;
  mcp_servers?: string[];
  files?: FileData[];
  model?: string;
  order: number;
  tool_settings?: Record<string, Record<string, unknown>>;
  custom_data?: { foundry_agent?: string };
}

export const useListAssistants = ({ auto = true, admin = false }) => {
  const { user } = useAuth();
  const [assistants, setAssistants] = useState<IAssistantsList[]>([]);
  const [defaultAssistant, setDefaultAssistant] = useState<IAssistantsList | null>(null);
  const { updateChatSettings } = useChatInteract();
  const hasSetupDefault = useRef(false);
  // const navigate = useNavigate();
  const fetchAssistants = useCallback(async () => {
    try {
      setAssistants([]);
      const url = !admin ? '/api/v1/assistants/list-view' : '/api/v1/assistants';
      const response = await api.get(url);
      if (response.data && response.data.length > 0) {
        setAssistants(response.data.sort((a: IAssistantsList, b: IAssistantsList) => a.order - b.order));
      }
    } catch (error: any) {
      toast.error(manageErrors(error?.status) ?? 'Error fetching assistants');
      // navigate('/unauthorized');
      setAssistants([]);
    }
  }, [user]);

  useEffect(() => {
    if (assistants.length > 0 && !defaultAssistant && !hasSetupDefault.current) {
      setDefaultAssistant(assistants[0]);
      updateChatSettings({ assistant: assistants[0] });
      hasSetupDefault.current = true;
    }
  }, [assistants, updateChatSettings, defaultAssistant]);

  useEffect(() => {
    if (auto) {
      fetchAssistants();
    }
  }, [auto, fetchAssistants]);

  return { assistants, fetchAssistants, defaultAssistant, setDefaultAssistant };
};
